import { render, staticRenderFns } from "./DetailsItemSimpleText.vue?vue&type=template&id=9ca0c4fc&scoped=true"
import script from "./DetailsItemSimpleText.vue?vue&type=script&lang=js"
export * from "./DetailsItemSimpleText.vue?vue&type=script&lang=js"
import style0 from "./DetailsItemSimpleText.vue?vue&type=style&index=0&id=9ca0c4fc&prod&scoped=true&lang=css"
import style1 from "./DetailsItemSimpleText.vue?vue&type=style&index=1&id=9ca0c4fc&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9ca0c4fc",
  null
  
)

export default component.exports